import { reportError } from 'shared/services/raygunService';
import { usePortalApi } from 'shared/const/api-backend';

const useInvoicingService = () => {
  const api = usePortalApi();

  const getInvoices = async (agencyId) => {
    try {
      const response = await api.get(`proxy/v1/invoicing/${agencyId}`);

      return response.data.data;
    } catch (error) {
      reportError(error);

      throw new Error('Failed to fetch invoices for agency.');
    }
  };

  const getInvoicingAgencies = async () => {
    try {
      const response = await api.get(`proxy/v1/invoicing`);

      return response.data.data;
    } catch (error) {
      reportError(error);

      throw new Error('Failed to fetch invoicing agencies.');
    }
  };

  return {
    getInvoices,
    getInvoicingAgencies,
  };
};

export default useInvoicingService;
